import { FC } from "react";
import { Stack, Typography } from "@mui/material";

interface ParagraphSectionProps {
  title: string;
  paragraphs: string[];
}

export const ParagraphSection: FC<ParagraphSectionProps> = ({
  title,
  paragraphs,
}) => {
  return (
    <Stack>
      <Typography fontWeight={600} variant="h6" gutterBottom>
        {title}
      </Typography>
      <Stack gap={0.5}>
        {paragraphs.map((paragraph, index) => (
          <Typography key={index}>{paragraph}</Typography>
        ))}
      </Stack>
    </Stack>
  );
};
